// extracted by mini-css-extract-plugin
module.exports = {"container":"gameChangerLabel_container__BU8qU","cornerQuantity":"gameChangerLabel_cornerQuantity__06bLC"};